export const UPLOADS = 'https://studiowebvip.com/wp-content/uploads/'
export const LOGO = UPLOADS + 'logo-studioweb-2.png'

// TODO: replace with the published GHL funnel URL (SWV - Lead Response Diagnostic)
export const DIAGNOSTIC_URL = '#diagnostic'

export const NAV = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Blog', href: '#blog' },
  { label: 'Contact Us', href: '#contact' },
]

export const SOCIALS = [
  { label: 'Facebook', href: 'https://www.facebook.com/StudiowebVIPM/' },
  { label: 'Instagram', href: 'https://www.instagram.com/studiowebvip/' },
  { label: 'Tiktok', href: 'https://www.tiktok.com/@studiowebvip_' },
  { label: 'YouTube', href: 'https://www.youtube.com/@StudioWebVIP' },
]

export const CONTACT = {
  location: 'Miami, Florida · Serving Clients Nationwide',
  phone: '+1 (607) 307-3316',
  phoneHref: 'tel:+16073073316',
  email: 'info@studiowebvip.com',
}

export const LEGAL = [
  { label: 'Privacy Policy', href: 'https://studiowebvip.com/privacy-policy/' },
  { label: 'Terms & Conditions', href: 'https://studiowebvip.com/terms-conditions/' },
  { label: 'Refund & Cancellation Policy', href: 'https://studiowebvip.com/refund-cancellation-policy/' },
]
